import { useState } from 'react'
import { router } from '@inertiajs/react'
import AdminLayout from '../../layouts/AdminLayout'
import Monogram from '../../components/Monogram'

function TeamRow({ team, editionSlug }) {
  const [name, setName] = useState(team.name)
  const [shortName, setShortName] = useState(team.shortName)
  const [monogram, setMonogram] = useState(team.monogram)
  const [color, setColor] = useState(team.color)
  const [saving, setSaving] = useState(false)

  function save() {
    setSaving(true)
    router.patch(
      `/teams/${team.id}`,
      {
        edition_slug: editionSlug,
        team: { name, short_name: shortName, monogram, color },
      },
      {
        preserveScroll: true,
        onFinish: () => setSaving(false),
      }
    )
  }

  return (
    <div className="adm-fx" style={{ cursor: 'default', flexWrap: 'wrap', gap: '10px' }}>
      <Monogram team={{ monogram, color }} size={34} />
      <div className="field" style={{ flex: '2 1 180px', margin: 0 }}>
        <label>Nome</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div className="field" style={{ flex: '1 1 120px', margin: 0 }}>
        <label>Curto</label>
        <input value={shortName} onChange={(e) => setShortName(e.target.value)} />
      </div>
      <div className="field" style={{ flex: '0 1 70px', margin: 0 }}>
        <label>Mono</label>
        <input value={monogram} maxLength={3} onChange={(e) => setMonogram(e.target.value)} />
      </div>
      <div className="field" style={{ flex: '0 1 60px', margin: 0 }}>
        <label>Cor</label>
        <input type="color" value={color} onChange={(e) => setColor(e.target.value)} />
      </div>
      <button className="btn" style={{ width: 'auto', margin: 0, padding: '11px 16px' }} type="button" onClick={save} disabled={saving}>
        Gravar
      </button>
    </div>
  )
}

export default function Teams({ currentEdition, editions, teams = [] }) {
  const groups = {}
  teams.forEach((t) => {
    const key = t.group || '—'
    ;(groups[key] ||= []).push(t)
  })

  return (
    <AdminLayout currentEdition={currentEdition} editions={editions} active="teams">
      {Object.keys(groups)
        .sort()
        .map((groupName) => (
          <div key={groupName} style={{ marginBottom: '24px' }}>
            <div className="sechead" style={{ marginBottom: '12px' }}>
              <h3>Grupo {groupName}</h3>
              <div className="rule" />
            </div>
            <div className="adm-list">
              {groups[groupName].map((t) => (
                <TeamRow key={t.id} team={t} editionSlug={currentEdition.slug} />
              ))}
            </div>
          </div>
        ))}
    </AdminLayout>
  )
}
